export default "__VITE_ASSET__CTDxEzDU__"